import React from "react";
import { Button } from "@material-ui/core";
import ReactModal from "react-modal-resizable-draggable";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  width100: {
    width: "100%",
  },
  bodyHeader: {
    background: "#b4d6f1",
    padding: ".3em",
    marginBottom: "1em",
  },
  modalFooter: {
    textAlign: "right",
    padding: "1em",
  },
  deActivateButton: {
    textTransform: "capitalize",
    backgroundColor: "#01345d",
  },
  textEditor: {
    overflow: "hidden",
    minHeight: 250,
  },
  company: {
    display: "flex",
    justifyContent: "space-around",
  },
}));
const WarningsModal = (props) => {
  const {
    warnings,
    openModal,
    start,
    end,
    handleAction,
    activeText,
    footer,
    handleClose,
    initHeight,
  } = props;

  const classes = useStyles();
  return (
    <ReactModal
      initWidth={600}
      initHeight={initHeight ? initHeight : 160}
      top={"25%"}
      disableMove={true}
      left={"30%"}
      isOpen={openModal}
      disableResize={true}
      disableHorizontalMove={true}
    >
      <div className="modal-title-style">
        {warnings.slice(start, end).map((ele, index) => {
          return <span className="title-modal pl-3">{ele.heading}</span>;
        })}
      </div>
      <div>
        <div>
          {warnings.slice(start, end).map((ele, index) => {
            return <div className="p-3">{ele.content}</div>;
          })}
          {footer && <div className="pl-3 pr-3">{footer}</div>}
          <hr />
          <div className={""}>
            {activeText && (
              <>
                <Button
                  type="button"
                  variant="contained"
                  className={`${classes.deActivateButton} mr-1`}
                  color="primary"
                  style={{ float: "right" }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  className={`${classes.deActivateButton} mr-1`}
                  color="primary"
                  style={{ float: "right" }}
                  onClick={()=>{handleAction(false)}}
                >
                  No
                </Button>
              </>
            )}
            <Button
              type="button"
              variant="contained"
              className={`${classes.deActivateButton} mr-1`}
              color="primary"
              style={{ float: "right" }}
              onClick={()=>{handleAction(true)}}
            >
              {activeText ? "Yes" : "Ok"}
            </Button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};
export default WarningsModal;
